export const SERVER_URL = 'https://api.hitit7mini.store/api/';